var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"text-uppercase px-2 px-sm-4",style:({ color: _vm.color.foreground }),attrs:{"color":_vm.color.background,"small":""}},[_vm._v(" Time Remaining: "+_vm._s(_vm.formattedTimeRemaining)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }